import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { loadState } from './localStorage'
import rootReducer from './reducers/rootReducer'

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

const create = (isBrowser) => {
  if (isBrowser) {
    return createStore(
      rootReducer,
      loadState(),
      composeEnhancers(applyMiddleware(thunk))
    )
  }

  return createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))
}

export default create
